import {DxDataGridComponent} from 'devextreme-angular';

// Brings the row being edited back into view and puts the caret in its first editor.
export function focusEditRow(grid?: DxDataGridComponent): void {
  const instance = grid?.instance;
  if (!instance) return;
  const key = instance.option('editing.editRowKey');
  const focusEditor = () =>
    (instance.element().querySelector('.dx-edit-row .dx-texteditor-input') as HTMLElement | null)?.focus();
  if (key == null) {
    focusEditor();
    return;
  }
  instance.navigateToRow(key).then(focusEditor);
}
